import { render } from "./receiver.vue?vue&type=template&id=7d8d1b44&scoped=true"
import script from "./receiver.vue?vue&type=script&lang=js"
export * from "./receiver.vue?vue&type=script&lang=js"

import "./receiver.vue?vue&type=style&index=0&id=7d8d1b44&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d8d1b44"]])

export default __exports__